import React, { useState } from 'react';
import LookupField from './LookupField';

const LookupFieldDemo = () => {
  const [formData, setFormData] = useState({
    jobCode: '',
    wellStatus: '',
    customLookup: ''
  });

  // Sample field configurations for different lookup types
  const jobCodeField = {
    name: 'jobCode',
    label: 'Job Code',
    options: 'lookup',
    lookupTable: 'JobCode',
    lookupValueColumn: 'JobCode',
    lookupDisplayColumn: 'JobDescription'
  };

  const wellStatusField = {
    name: 'wellStatus',
    label: 'Well Status',
    options: 'lookup',
    lookupTable: 'WellStatus',
    lookupValueColumn: 'StatusCode',
    lookupDisplayColumn: 'StatusName'
  };

  const handleFieldChange = (fieldName, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form Data:', formData);
    alert(`Form submitted with data:\n${JSON.stringify(formData, null, 2)}`);
  };

  return (
    <div style={{ 
      maxWidth: '600px', 
      margin: '20px auto', 
      padding: '20px', 
      border: '1px solid #e0e0e0', 
      borderRadius: '8px',
      backgroundColor: '#f8f9fa'
    }}>
      <h2>🔗 Lookup Field Demo</h2>
      <p style={{ color: '#6c757d', marginBottom: '20px' }}>
        This demo shows how lookup fields work. Make sure you've created sample lookup data first 
        using the "Create Sample Lookup Data" button in Admin Configuration.
      </p>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>
            {jobCodeField.label}:
          </label>
          <LookupField
            field={jobCodeField}
            value={formData.jobCode}
            onChange={(value) => handleFieldChange('jobCode', value)}
            placeholder="Select a job code..."
          />
          <small style={{ color: '#6c757d' }}>
            Lookup: {jobCodeField.lookupTable}.{jobCodeField.lookupValueColumn} → {jobCodeField.lookupDisplayColumn}
          </small>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>
            {wellStatusField.label}:
          </label>
          <LookupField
            field={wellStatusField}
            value={formData.wellStatus}
            onChange={(value) => handleFieldChange('wellStatus', value)}
            placeholder="Select well status..."
          />
          <small style={{ color: '#6c757d' }}>
            Lookup: {wellStatusField.lookupTable}.{wellStatusField.lookupValueColumn} → {wellStatusField.lookupDisplayColumn}
          </small>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <button 
            type="submit" 
            style={{ 
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Submit Form
          </button>
          <button 
            type="button" 
            onClick={() => setFormData({ jobCode: '', wellStatus: '', customLookup: '' })}
            style={{ 
              padding: '10px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginLeft: '10px'
            }}
          >
            Clear Form
          </button>
        </div>
      </form>

      <div style={{ 
        padding: '12px', 
        backgroundColor: '#e9ecef', 
        borderRadius: '4px',
        marginTop: '20px'
      }}>
        <h4>Current Form Values:</h4>
        <pre style={{ margin: '8px 0', fontSize: '0.9em' }}>
          {JSON.stringify(formData, null, 2)}
        </pre>
      </div>

      <div style={{ 
        padding: '12px', 
        backgroundColor: '#d1ecf1', 
        borderRadius: '4px',
        marginTop: '12px',
        fontSize: '0.9em'
      }}>
        <h4>💡 How it works:</h4>
        <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
          <li>The dropdown shows the <strong>display column</strong> (e.g., "Drilling Operations")</li>
          <li>But the form stores the <strong>value column</strong> (e.g., "DRILL")</li>
          <li>This allows user-friendly labels while maintaining database consistency</li>
          <li>Perfect for foreign key relationships and code tables</li>
        </ul>
      </div>
    </div>
  );
};

export default LookupFieldDemo; 